class Logger {
  constructor() {
    this.level = 3;
    this.data = [];
    this.style = `
      background: #1b1b1b;
      font-family: Menlo, Monaco, Consolas, monospace;
      color: #f08a22;
      padding: 3px;
      border: 2px solid #f08a22;`;
  }

  error(...args) {
    if (this.level > 0) {
      console.error(...args);
    }
    this.saveLog(args);
  }

  warn(...args) {
    if (this.level > 1) {
      console.warn(...args);
    }
    this.saveLog(args);
  }

  info(...args) {
    if (this.level > 2) {
      console.info(...args);
    }
  }

  group(...args) {
    if (this.level > 3) {
      console.group(...args);
    }
  }

  groupEnd() {
    if (this.level > 3) {
      console.groupEnd();
    }
  }

  debug(...args) {
    if (this.level > 4) {
      console.debug(...args);
    }
  }

  table(...args) {
    if (this.level > 3) {
      console.table(...args);
    }
  }

  log(...args) {
    if (this.level > 3) {
      console.log(...args);
    }
    this.saveLog(args);
  }

  setLevel(level) {
    this.level = level;
  }

  off() {
    this.setLevel(2);
  }

  on() {
    console.log('%cBatch-Go Logger', this.style);
    this.setLevel(4);
  }

  saveLog(args) {
    const d = new Date();
    let lastEntry = this.data.length ? this.data[this.data.length - 1] : '';

    if (!lastEntry.includes(args.join(' '))) {
      this.data.push(`${d.toUTCString()}: ${args.join(' ')} \n`);
    }

    if (this.data.length > 1000) {
      this.data.shift();
    }
  }

  display() {
    this.data.forEach(v => {
      console.log(v);
    });
  }

  save() {
    const filename = `CloudBatch-logger-${Date.now()}.txt`;
    const blob = new Blob(this.data, {type: 'text/plain'}),
      e = document.createEvent('MouseEvents'),
      a = document.createElement('a');

    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl =  ['text/plain', a.download, a.href].join(':');
    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
  }

  clear() {
    this.data = [];
  }

  get isOn() {
    return this.level > 2;
  }
}

const logger = new Logger();
window.SYSDYNE_LOGGER = logger;

export default logger;
